import React from "react";
import { Link } from "react-router-dom";
import localapp from "./assets/image/Brand nfc.png";

const Footerbrand = () => {
  return (
    <div>
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 col-md-7 col-12 text-center text-md-start mb-4 mb-md-0">
              <p className="mb-2 fw-semibold fs-5 text-secondary">
                <Link to="/contact" className="text-decoration-none text-secondary">
                  Create Smart Business Cards
                </Link>
              </p>
              <h2 className="fw-bold text-dark display-6 mb-3">
                Connect With Your Customers Using <br className="d-none d-md-block" /> 9|R NFC Cards and Build a <br className="d-none d-md-block" />
                <span className="text-orange">Lifetime Relationship.</span>
              </h2>
              <p className="lead text-secondary mb-0">
                Grow your business with{" "}
                <span className="text-orange fw-bold">9R NFC CARD.</span>
              </p>
            </div>
            <div className="col-lg-5 col-md-5 col-12 text-center">
              <img src={localapp} className="w-100 img-fluid" alt="NFC Portfolio" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Footerbrand;
